import { FormControl } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'

import { FormLabel } from '../../components/FormLabel'
import { FormGroup } from '../../components/FormGroup'
import { InputGroup } from '../../components/InputGroup'
import { useContext } from 'react'
import { insuranceParamsContext } from '../../layouts/Wizard'
import { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'

export const AdditionalPropertyInfoKoop = () => {
  const { insuranceParams } = useContext(insuranceParamsContext)

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, formState: { errors }, getFieldState, setValue, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const floorsCount = getValues('property.additionalDataKoop.floorsCount')
  const atticFloorAreaRequired = getValues('property.additionalDataKoop.atticFloorAreaRequired')
  const cellarFloorAreaRequired = getValues('property.additionalDataKoop.cellarFloorAreaRequired')

  return (
    <>
      {floorsCount > 0 &&
        <FormGroup>
          <FormControl isRequired isInvalid={!!errors.property?.additionalDataKoop?.groundFloorArea}>
            <FormLabel>Plocha přízemí</FormLabel>
            <InputGroup
              isDisabled={isContracted}
              id="groundFloorArea"
              //htmlSize={8}
              autoComplete="off"
              inputMode="decimal"
              errors={errors.property?.additionalDataKoop?.groundFloorArea}
              {...register('property.additionalDataKoop.groundFloorArea')}
            />
          </FormControl>

          {floorsCount > 1 &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataKoop?.firstFloorArea}>
              <FormLabel>Plocha 1. patra</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="firstFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataKoop?.firstFloorArea}
                {...register('property.additionalDataKoop.firstFloorArea')}
              />
            </FormControl>
          }

          {floorsCount > 2 &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataKoop?.secondFloorArea}>
              <FormLabel>Plocha 2. patra</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="secondFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataKoop?.secondFloorArea}
                {...register('property.additionalDataKoop.secondFloorArea')}
              />
            </FormControl>
          }
        </FormGroup>
      }

      {(atticFloorAreaRequired || cellarFloorAreaRequired) &&
        <FormGroup>
          {atticFloorAreaRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataKoop?.atticFloorArea}>
              <FormLabel>Plocha podkroví</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="atticFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataKoop?.atticFloorArea}
                {...register('property.additionalDataKoop.atticFloorArea')}
              />
            </FormControl>
          }

          {cellarFloorAreaRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataKoop?.cellarFloorArea}>
              <FormLabel>Plocha sklepa</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="cellarFloorArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataKoop?.cellarFloorArea}
                {...register('property.additionalDataKoop.cellarFloorArea')}
              />
            </FormControl>
          }
        </FormGroup>
      }

      <FormControl isReadOnly isInvalid={!!errors.property?.additionalDataKoop?.totalFloorArea}>
        <FormLabel>Zadaná celková podlahová plocha</FormLabel>
        <InputGroup
          isDisabled={isContracted}
          id="totalFloorArea"
          //htmlSize={8}
          autoComplete="off"
          inputMode="decimal"
          errors={errors.property?.additionalDataKoop?.totalFloorArea}
          {...register('property.additionalDataKoop.totalFloorArea')}
        />
      </FormControl>

    </>
  )
}
